import { z } from "zod";

export const ReadmeWebhookRequestBodySchema = z.object({
  email: z.string(),
});
export type ReadmeWebhookRequestBodyType = z.infer<
  typeof ReadmeWebhookRequestBodySchema
>;
